import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RiskifiedOtp } from './components/riskifiedOtp/RiskifiedOtp';
import { PublicApiClientProvider } from '@jbhi-fi/components/src/context/PublicApiClientProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import JbGlobalThemes from '@jbhi-fi/lanyard-ui/themes/jb/JbGlobalThemes';
import { ContentfulApiClient, ContentfulPreviewThemeApiClient } from '../api/contentful/ContentfulClient';

const contentfulThemeApiClient = new ContentfulPreviewThemeApiClient();
const contentfulClient = new ContentfulApiClient();

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('verifyidentity-container');
  if (container) {
    const root = createRoot(container);
    root.render(
      <QueryClientProvider client={new QueryClient()}>
        <PublicApiClientProvider
          contentfulThemeApiClient={contentfulThemeApiClient}
          contentfulClient={contentfulClient}
        >
          <JbGlobalThemes />
          <RiskifiedOtp />
        </PublicApiClientProvider>
      </QueryClientProvider>
    );
  }
});
